import { getYear } from 'date-fns';
import { WAIT_LIST } from '../constants';
import { RECORD_CLICK, HANDLE_CLICK, SETUP_INIT_DATA } from './_types';
import { CLICK, HANDLE_LINK_CLICK } from '../../root/actions/_types';
import { SET_TOGGLED_MONTHS } from '../mutations/_types';

const pageName = 'opo:course details';

export default {
  [SETUP_INIT_DATA]: ({ commit }, { sessionsByMonth }) => {
    const toggledMonths = [];
    let firstMonthWithAvailability = false;

    Object.keys(sessionsByMonth).forEach((monthKey) => {
      const [month, sessionYear] = monthKey.split(' ');
      const sessions = sessionsByMonth[monthKey];
      const year = getYear(Date.now());
      const monthName = year === parseInt(sessionYear, 10) ? month : `${month} ${sessionYear}`;
      const waitlistOnly = sessions.reduce(
        (waitlist, session) => waitlist && session.spots.status === WAIT_LIST,
        true,
      );

      if (!firstMonthWithAvailability && !waitlistOnly) {
        toggledMonths.push(monthName);
        firstMonthWithAvailability = true;
      }
    });

    commit(SET_TOGGLED_MONTHS, toggledMonths);
  },
  [RECORD_CLICK]: ({ dispatch }, payload) => {
    // convenience method for recording analytics
    const { section, linkText, ...rest } = payload;
    const sectionText = section ? `${section}_` : '';
    const clickData = {
      linkName: `${pageName}_${sectionText}${linkText}`,
      // linkName is overridable by putting "linkName" in the payload
      ...rest,
    };
    return dispatch(CLICK, clickData, { root: true });
  },
  [HANDLE_CLICK]: ({ dispatch }, payload) => {
    // convenience method to handle recording analytics on link clicks
    // and navigation (via window.history API)
    const { analytics, ...nextPayload } = payload;
    if (payload.event.button !== 0) return;
    const analyticsPromise = dispatch(RECORD_CLICK, analytics);
    if (payload.external) {
      nextPayload.before = Promise.resolve(analyticsPromise).then(Promise.resolve(payload.before));
    }
    dispatch(HANDLE_LINK_CLICK, nextPayload, { root: true });
  },
};
